import React from 'react';
import Skeleton from "react-loading-skeleton";
import LoadingSpinner from './LoadingSpinner'
import Banner from './Banner'

export default function ContentSkeleton({spinner}) {
	window.scrollTo(0, 0);
	return (
		<React.Fragment>
		{spinner && <LoadingSpinner/>}
			<Banner title={null} backgroundImage={null} />
			<div className="entry-content">
				<Skeleton count={5}/>
			</div>
		</React.Fragment>
	)
}